/*
 * Laurent — Werkstuecke (Auftrag Werkstuecke, Fassung 5).
 *
 * 1. Auswahl im Kaufbereich: Musterbild in der Liste, Sitz blendet Bezug aus,
 *    Wunschmass-Felder, Stueckzahl, Kasten "Ihre Auswahl" und die
 *    versteckten Felder des Kontaktformulars. Der Preis wird nie angefasst.
 * 2. Anfrage: Pflichtpruefung der E-Mail mit dem Text aus dem Entwurf,
 *    Adresse im Dankeszustand.
 * 3. Mustertafel und Galerie: Ebenen am <body>, oeffnen ohne Scrollbewegung,
 *    Seite gesperrt, Fokus in der Ebene, Escape/Schleier/Knoepfe schliessen,
 *    Fokus zurueck auf den Ausloeser.
 * (Ein Typfilter im Browser ist seit 18.10.2026 entfallen: die Unterkategorien
 * sind eigene Kollektionen ueber w-Tags, die Filterzeile verlinkt sie.)
 *
 * Faellt das Skript aus, bleiben Listen, Formular und Karten bedienbar; es
 * fehlen nur die Kopplungen. Gilt nur fuer Seiten mit Werkstueck-Sektionen —
 * das Skript wird nur von diesen geladen.
 */
(function () {
  'use strict';

  if (window.lhWerk) return;
  window.lhWerk = true;

  var SPEICHER = 'lhWerkMail';

  function alle(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function text(el, wert) {
    if (el) el.textContent = wert;
  }

  /* ---------------------------------------------------------------------
     Ebenen: Mustertafel und Galerie
     --------------------------------------------------------------------- */

  var offen = null; // { ebene, panel, ausloeser, y }

  function fokussierbar(root) {
    return alle(
      root,
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
    ).filter(function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
  }

  function sperren() {
    var html = document.documentElement;
    var breite = window.innerWidth - html.clientWidth;
    html.style.setProperty('--lh-werk-scrollbreite', (breite > 0 ? breite : 0) + 'px');
    html.classList.add('lh-werk-gesperrt');
  }

  function entsperren() {
    var html = document.documentElement;
    html.classList.remove('lh-werk-gesperrt');
    html.style.removeProperty('--lh-werk-scrollbreite');
  }

  function oeffnen(ebene, ausloeser, ziel) {
    if (!ebene) return;
    // Mustertafel aus der Anfrage-Nebenseite heraus: die Anfrage bleibt
    // darunter offen und bekommt den Fokus zurueck (Foto 4, 19.10.2026).
    var unter = null;
    if (offen && offen.ebene.hasAttribute('data-werk-anfrageseite') && ebene.hasAttribute('data-werk-tafel')) {
      unter = offen;
    } else if (offen) {
      schliessen();
    }
    var y = unter ? unter.y : window.scrollY;
    var panel = ebene.querySelector('[data-werk-tafel-panel], [data-werk-galerie-panel], [data-werk-anfrageseite-panel]');
    ebene.hidden = false;
    sperren();
    offen = { ebene: ebene, panel: panel, ausloeser: ausloeser, y: y, unter: unter };
    if (panel) {
      panel.scrollTop = 0;
      if (ziel) {
        var kopf = panel.querySelector('.lh-werk-galerie__kopf, .lh-werk-tafel__kopf');
        var abzug = kopf ? kopf.offsetHeight : 0;
        panel.scrollTop = Math.max(0, ziel.offsetTop - abzug - 12);
      }
      panel.focus({ preventScroll: true });
    }
    // Die Seite darf nicht springen (Auftrag 2a): Stand vorher = nachher.
    if (window.scrollY !== y) window.scrollTo(0, y);
  }

  function schliessen() {
    if (!offen) return;
    var o = offen;
    offen = null;
    o.ebene.hidden = true;
    if (o.unter) {
      offen = o.unter;
      if (o.ausloeser && document.contains(o.ausloeser)) {
        o.ausloeser.focus({ preventScroll: true });
      }
      return;
    }
    entsperren();
    if (window.scrollY !== o.y) window.scrollTo(0, o.y);
    if (o.ausloeser && document.contains(o.ausloeser)) {
      o.ausloeser.focus({ preventScroll: true });
    }
  }

  document.addEventListener('keydown', function (e) {
    if (!offen) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      schliessen();
      return;
    }
    if (e.key !== 'Tab' || !offen.panel) return;
    var ziele = fokussierbar(offen.panel);
    if (!ziele.length) {
      e.preventDefault();
      offen.panel.focus({ preventScroll: true });
      return;
    }
    var erstes = ziele[0];
    var letztes = ziele[ziele.length - 1];
    var aktiv = document.activeElement;
    if (e.shiftKey && (aktiv === erstes || aktiv === offen.panel)) {
      e.preventDefault();
      letztes.focus({ preventScroll: true });
      // Nur die Ebene scrollt, die Seite ist gesperrt und bleibt stehen.
      letztes.scrollIntoView({ block: 'nearest' });
    } else if (!e.shiftKey && aktiv === letztes) {
      e.preventDefault();
      erstes.focus({ preventScroll: true });
    } else if (!offen.panel.contains(aktiv)) {
      e.preventDefault();
      erstes.focus({ preventScroll: true });
    }
  });

  // Ebenen an <body> haengen: die Infospalte traegt ein transform, darin
  // waere position: fixed falsch verankert. Eine Ebene mit derselben id, die
  // schon am <body> haengt (Theme-Editor laedt Sektionen neu), wird ersetzt.
  function ebenenAnBody(root) {
    alle(root, '[data-werk-tafel], [data-werk-galerie], [data-werk-anfrageseite]').forEach(function (ebene) {
      if (ebene.parentNode === document.body) return;
      if (ebene.id) {
        var alt = document.body.querySelector(':scope > #' + CSS.escape(ebene.id));
        if (alt && alt !== ebene) alt.remove();
      }
      document.body.appendChild(ebene);
    });
  }

  function tafel() {
    return document.querySelector('body > [data-werk-tafel]') || document.querySelector('[data-werk-tafel]');
  }

  document.addEventListener('click', function (e) {
    var auf = e.target.closest('[data-werk-tafel-auf]');
    if (auf) {
      e.preventDefault();
      oeffnen(tafel(), auf);
      return;
    }
    // Link auf #muster: Tafel auf dieser Seite oeffnen, wenn es hier eine gibt
    // (Startseite seit 27.10.2026). Schliessen laesst einen dann hier stehen.
    // Ohne Tafel auf der Seite fuehrt der Link wie bisher zu den Werkstuecken.
    var musterLink = e.target.closest('a[href*="#muster"]');
    if (musterLink && tafel()) {
      e.preventDefault();
      oeffnen(tafel(), musterLink);
      return;
    }
    var gal = e.target.closest('[data-werk-galerie-auf]');
    if (gal) {
      e.preventDefault();
      var projekte = gal.closest('[data-werk-projekte]');
      var ebene = projekte && projekte.querySelector('[data-werk-galerie]');
      if (!ebene) ebene = document.querySelector('body > [data-werk-galerie]');
      var nr = gal.getAttribute('data-werk-galerie-auf');
      var ziel = ebene && ebene.querySelector('[data-werk-galerie-bild="' + nr + '"]');
      oeffnen(ebene, gal, nr !== '0' ? ziel : null);
      return;
    }
    var anf = e.target.closest('[data-werk-anfrage-auf]');
    if (anf) {
      e.preventDefault();
      if (handy()) {
        anfragePlatz();
        oeffnen(anfrageEbene(), anf);
      }
      return;
    }
    if (e.target.closest('[data-werk-tafel-zu], [data-werk-galerie-zu], [data-werk-anfrageseite-zu]')) {
      e.preventDefault();
      schliessen();
      return;
    }
    var muster = e.target.closest('[data-werk-muster]');
    if (muster) {
      e.preventDefault();
      musterWaehlen(muster);
    }
  });

  /* ---------------------------------------------------------------------
     Auswahl im Kaufbereich
     --------------------------------------------------------------------- */

  function kauf() {
    return document.querySelector('[data-werk-kauf]');
  }

  /* Anfrage als Nebenseite (nur unter 750px, Fotos 3 und 4, 19.10.2026).
     Der Block .lh-werk-auswahl wandert am Handy in die Ebene und ab 750px
     zurueck an eine Marke in der Infospalte. Gesucht wird deshalb in
     Kaufbereich UND Ebene (q), nicht nur im Kaufbereich. */
  var HANDY = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;

  function handy() {
    return !!(HANDY && HANDY.matches);
  }

  function anfrageEbene() {
    return document.querySelector('body > [data-werk-anfrageseite]') || document.querySelector('[data-werk-anfrageseite]');
  }

  function q(sel) {
    var k = kauf();
    var e = anfrageEbene();
    return (k && k.querySelector(sel)) || (e && e.querySelector(sel)) || null;
  }

  function anfragePlatz() {
    var ebene = anfrageEbene();
    var platz = ebene && ebene.querySelector('[data-werk-anfrageseite-platz]');
    var block = q('[data-werk-auswahl]');
    if (!platz || !block) return;
    var marke = document.querySelector('[data-werk-auswahl-marke]');
    if (!marke) {
      marke = document.createElement('span');
      marke.hidden = true;
      marke.setAttribute('data-werk-auswahl-marke', '');
      block.parentNode.insertBefore(marke, block);
    }
    if (handy()) {
      if (block.parentNode !== platz) platz.appendChild(block);
    } else {
      if (offen && offen.ebene === ebene) schliessen();
      if (block.parentNode !== marke.parentNode) marke.parentNode.insertBefore(block, marke.nextSibling);
    }
  }

  function liste(root, art) {
    return q('[data-werk-select="' + art + '"]');
  }

  function gewaehlt(select) {
    return select && select.options[select.selectedIndex];
  }

  function materialText(opt) {
    if (!opt) return '';
    var name = opt.getAttribute('data-name') || opt.textContent.trim();
    var code = opt.getAttribute('data-code');
    return code ? name + '   [' + code + ']' : name;
  }

  function feld(root, art) {
    return q('[data-werk-feld="' + art + '"]');
  }

  function setzeFeld(root, art, wert, aktiv) {
    var f = feld(root, art);
    if (!f) return;
    f.value = wert;
    f.disabled = !aktiv;
  }

  function musterbild(select) {
    if (!select) return;
    var bild = select.parentNode.querySelector('[data-werk-musterbild]');
    var opt = gewaehlt(select);
    var src = opt && opt.getAttribute('data-bild');
    if (!bild) return;
    if (src) {
      bild.src = src;
      bild.hidden = false;
      select.parentNode.classList.add('lh-werk-liste__feld--mitbild');
    } else {
      bild.removeAttribute('src');
      bild.hidden = true;
      select.parentNode.classList.remove('lh-werk-liste__feld--mitbild');
    }
  }

  function zahl(wert) {
    var z = String(wert || '').replace(/[^0-9,\.]/g, '').replace(/^[,\.]+/, '');
    return z;
  }

  function aktualisieren() {
    var root = kauf();
    if (!root) return;

    var holz = liste(root, 'holz');
    var sitz = liste(root, 'sitz');
    var bezug = liste(root, 'bezug');
    var mass = liste(root, 'mass');
    var menge = q('[data-werk-menge-feld]');
    var titel = root.getAttribute('data-werk-titel') || '';

    var ausHolz = sitz && sitz.value === 'holz';
    var mitBezug = !!bezug && !ausHolz;

    var bezugListe = q('[data-werk-liste="bezug"]');
    if (bezugListe) bezugListe.hidden = !mitBezug;

    musterbild(holz);
    musterbild(bezug);

    // Masse
    var wunschRahmen = q('[data-werk-wunsch]');
    var istWunsch = mass && mass.value === 'wunsch';
    if (wunschRahmen) wunschRahmen.hidden = !istWunsch;

    var massFeld = feld(root, 'mass');
    var mase = massFeld ? massFeld.getAttribute('data-werk-mase') || '' : '';
    var massText = mase;
    if (istWunsch) {
      var teile = ['b', 't', 'h'].map(function (k) {
        var inp = q('[data-werk-mass="' + k + '"]');
        var w = inp ? zahl(inp.value) : '';
        if (!w && inp) w = inp.getAttribute('data-werk-std') || '…';
        return k.toUpperCase() + ' ' + (w || '…');
      });
      massText = 'Wunschmaß ' + teile.join(' × ') + ' cm';
    }

    // Stueckzahl
    var n = 1;
    if (menge) {
      n = parseInt(menge.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > 99) n = 99;
    }

    // Versteckte Felder
    setzeFeld(root, 'holz', materialText(gewaehlt(holz)), !!holz);
    setzeFeld(root, 'sitz', ausHolz ? 'Aus Holz' : 'Gepolstert', !!sitz);
    setzeFeld(root, 'bezug', materialText(gewaehlt(bezug)), mitBezug);
    setzeFeld(root, 'mass', massText, !!massText);
    setzeFeld(root, 'menge', String(n), true);

    // Kasten "Ihre Auswahl"
    var kasten = q('[data-werk-kasten]');
    if (kasten) {
      var hOpt = gewaehlt(holz);
      var bOpt = gewaehlt(bezug);
      var zeilen = [['Stück', titel]];
      if (holz) zeilen.push(['Holz', hOpt ? hOpt.getAttribute('data-name') : '']);
      if (sitz) zeilen.push(['Sitz', ausHolz ? 'Aus Holz' : 'Gepolstert']);
      if (mitBezug) zeilen.push(['Bezug', bOpt ? bOpt.getAttribute('data-name') : '']);
      if (massText) zeilen.push(['Maße', massText]);
      zeilen.push(['Stückzahl', String(n)]);
      kasten.innerHTML = '';
      zeilen.forEach(function (z) {
        var dt = document.createElement('dt');
        var dd = document.createElement('dd');
        dt.textContent = z[0];
        // Kein Zeilenanfang mit "·": das Leerzeichen davor bindet.
        dd.textContent = (z[1] || '').replace(/ · /g, '\u00a0· ');
        kasten.appendChild(dt);
        kasten.appendChild(dd);
      });
    }

    // Mustertafel: Rahmen am gewaehlten Muster, Fusszeile
    var t = tafel();
    if (t && t.getAttribute('data-werk-modus') === 'produkt') {
      var hWert = holz ? holz.value : '';
      var bWert = mitBezug && bezug ? bezug.value : '';
      alle(t, '[data-werk-muster]').forEach(function (m) {
        var art = m.getAttribute('data-werk-art');
        var wert = m.getAttribute('data-werk-muster');
        var an = (art === 'holz' && wert === hWert) || (art === 'bezug' && wert === bWert);
        m.setAttribute('aria-pressed', an ? 'true' : 'false');
      });
      var fuss = t.querySelector('[data-werk-gewaehlt]');
      if (fuss) {
        var teileF = [];
        if (holz && gewaehlt(holz)) teileF.push(gewaehlt(holz).getAttribute('data-name'));
        if (mitBezug && gewaehlt(bezug)) teileF.push(gewaehlt(bezug).getAttribute('data-name'));
        else if (sitz && ausHolz) teileF.push('Sitz aus Holz');
        text(fuss, teileF.length ? 'Gewählt: ' + teileF.join(' · ') : '');
      }
    }
  }

  function musterWaehlen(knopf) {
    var root = kauf();
    if (!root) return;
    var art = knopf.getAttribute('data-werk-art');
    var wert = knopf.getAttribute('data-werk-muster');
    var select = liste(root, art);
    if (!select) return;
    var gibt = alle(select, 'option').some(function (o) { return o.value === wert; });
    if (!gibt) return;
    select.value = wert;
    if (art === 'bezug') {
      var sitz = liste(root, 'sitz');
      if (sitz) sitz.value = 'polster';
    }
    aktualisieren();
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest('[data-werk-kauf], [data-werk-anfrageseite]') && e.target.matches('select, input')) aktualisieren();
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-werk-mass], [data-werk-menge-feld]')) aktualisieren();
  });

  document.addEventListener('click', function (e) {
    var k = e.target.closest('[data-werk-menge]');
    if (!k) return;
    var root = k.closest('[data-werk-kauf], [data-werk-anfrageseite]');
    var inp = root && root.querySelector('[data-werk-menge-feld]');
    if (!inp) return;
    var n = parseInt(inp.value, 10);
    if (isNaN(n)) n = 1;
    n += parseInt(k.getAttribute('data-werk-menge'), 10);
    inp.value = String(Math.min(99, Math.max(1, n)));
    aktualisieren();
  });

  // Mengenfeld beim Verlassen auf 1–99 zurueckholen.
  document.addEventListener('focusout', function (e) {
    if (!e.target.matches('[data-werk-menge-feld]')) return;
    var n = parseInt(e.target.value, 10);
    if (isNaN(n) || n < 1) n = 1;
    if (n > 99) n = 99;
    e.target.value = String(n);
    aktualisieren();
  });

  /* ---------------------------------------------------------------------
     Anfrage
     --------------------------------------------------------------------- */

  function mailGueltig(wert) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(wert);
  }

  function mailFehler(form, zeigen) {
    var inp = form.querySelector('[data-werk-mail]');
    var hinweis = form.querySelector('[data-werk-mailfehler]');
    if (hinweis) hinweis.hidden = !zeigen;
    if (inp) {
      inp.classList.toggle('lh-feld__eingabe--fehler', zeigen);
      if (zeigen) {
        inp.setAttribute('aria-invalid', 'true');
        if (hinweis && hinweis.id) inp.setAttribute('aria-describedby', hinweis.id);
      } else {
        inp.removeAttribute('aria-invalid');
        inp.removeAttribute('aria-describedby');
      }
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.lh-werk-anfrage');
    if (!form) return;
    aktualisieren();
    var inp = form.querySelector('[data-werk-mail]');
    var wert = inp ? inp.value.trim() : '';
    if (!mailGueltig(wert)) {
      // stopImmediatePropagation: Shopifys hCaptcha haengt einen eigenen
      // submit-Lauscher an das Formular, der preventDefault nicht beachtet
      // und sonst trotzdem abschickt.
      e.preventDefault();
      e.stopImmediatePropagation();
      mailFehler(form, true);
      if (inp) inp.focus();
      return;
    }
    mailFehler(form, false);
    try {
      sessionStorage.setItem(SPEICHER, wert);
    } catch (err) {}
  }, true);

  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-werk-mail]')) return;
    var form = e.target.closest('.lh-werk-anfrage');
    if (form && mailGueltig(e.target.value.trim())) mailFehler(form, false);
  });

  function danke() {
    var box = document.querySelector('[data-werk-danke]');
    if (!box) return;
    var feld = box.querySelector('[data-werk-danke-mail]');
    var mail = '';
    try {
      mail = sessionStorage.getItem(SPEICHER) || '';
      sessionStorage.removeItem(SPEICHER);
    } catch (err) {}
    if (mail) text(feld, mail);
    // Screenreader hoeren die Bestaetigung; sichtbar aendert sich nichts,
    // der Anker der Weiterleitung hat den Kasten schon ins Bild geholt.
    box.focus();
  }

  /* ---------------------------------------------------------------------
     Start
     --------------------------------------------------------------------- */

  // Ohne Skript schicken Listen und Mengenfeld ihren Wert selbst (name + form=).
  // Mit Skript uebernehmen die versteckten Felder mit Klartext und Code —
  // die Listen verlieren dafuer ihren Namen, sonst kaeme jede Angabe doppelt.
  function namenAbgeben() {
    alle(document, '[data-werk-kauf] [data-werk-select], [data-werk-kauf] [data-werk-menge-feld], [data-werk-anfrageseite] [data-werk-select], [data-werk-anfrageseite] [data-werk-menge-feld]').forEach(function (el) {
      el.removeAttribute('name');
    });
  }

  // Nach dem Absenden laedt die Seite neu: Dank oder Fehler stehen dann in der
  // Nebenseite und waeren am Handy unsichtbar — sie oeffnet deshalb selbst.
  function anfrageNachAbsenden() {
    if (!handy()) return;
    var ebene = anfrageEbene();
    if (!ebene) return;
    var dank = ebene.querySelector('[data-werk-danke]');
    var fehler = alle(ebene, '.lh-werk-fehler[role="alert"]').some(function (el) {
      return !el.hidden;
    });
    if (dank || fehler) oeffnen(ebene, document.querySelector('[data-werk-anfrage-auf]'));
  }

  function start() {
    namenAbgeben();
    ebenenAnBody(document);
    anfragePlatz();
    aktualisieren();
    anfrageNachAbsenden();
    danke();
  }

  // Handy-Auswahlliste der Werkstuecke: Auswahl oeffnet die Kategorie (26.10.2026).
  document.addEventListener('change', function (e) {
    var liste = e.target.closest && e.target.closest('[data-werk-filter-liste]');
    if (liste && liste.value) window.location.href = liste.value;
  });

  // Rechner: „Filtern“ samt Anzahl rechts neben Titel und Text der Werkstuecke-Seite
  // (26.10.2026, Marcel). Am Handy bleibt beides im Raster unter den Schritten.
  function filterPlatz() {
    var kopf = document.querySelector('.lh-werk-kopf__inhalt');
    var reihe = document.querySelector('.lh-werk-filter');
    if (!kopf || !reihe) return;
    var liste = document.querySelector('.lh-werk-filter__liste');
    var zahl = document.querySelector('.lh-werk-filter__anzahl');
    if (!liste || !zahl) return;
    var platz = kopf.querySelector('.lh-werk-kopf__filter');
    if (!platz) {
      platz = document.createElement('div');
      platz.className = 'lh-werk-kopf__filter';
      var text = kopf.querySelector('.lh-werk-kopf__text');
      if (text) text.insertAdjacentElement('afterend', platz); else kopf.appendChild(platz);
    }
    if (window.matchMedia('(min-width: 750px)').matches) {
      platz.appendChild(zahl);
      platz.appendChild(liste);
      reihe.classList.add('lh-werk-filter--leer');
      kopf.classList.add('lh-werk-kopf__inhalt--filter');
    } else {
      reihe.appendChild(liste);
      reihe.appendChild(zahl);
      reihe.classList.remove('lh-werk-filter--leer');
      kopf.classList.remove('lh-werk-kopf__inhalt--filter');
    }
  }
  var FILTERBREITE = window.matchMedia('(min-width: 750px)');
  if (FILTERBREITE.addEventListener) FILTERBREITE.addEventListener('change', filterPlatz);

  // „Alle Muster ansehen“ auf der Startseite fuehrt auf #muster: Tafel sofort oeffnen.
  function musterAusLink() {
    if (window.location.hash === '#muster' && tafel()) oeffnen(tafel(), null);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(); filterPlatz(); musterAusLink(); });
  else { start(); filterPlatz(); musterAusLink(); }

  if (HANDY) {
    var wechsel = function () { anfragePlatz(); aktualisieren(); };
    if (HANDY.addEventListener) HANDY.addEventListener('change', wechsel);
    else if (HANDY.addListener) HANDY.addListener(wechsel);
  }

  // Theme-Editor: Sektionen werden neu geladen, ohne dass die Seite neu baut.
  document.addEventListener('shopify:section:load', function (e) {
    schliessen();
    namenAbgeben();
    ebenenAnBody(e.target || document);
    anfragePlatz();
    aktualisieren();
  });

  // Entfernte Sektion: ihre Ebene haengt noch am <body> und wuerde sonst
  // weiter geoeffnet.
  document.addEventListener('shopify:section:unload', function (e) {
    schliessen();
    var id = e.detail && e.detail.sectionId;
    if (!id) return;
    ['WerkTafel-', 'WerkGalerie-', 'WerkAnfrageSeite-'].forEach(function (p) {
      var alt = document.getElementById(p + id);
      if (alt && alt.parentNode === document.body) alt.remove();
    });
  });
})();
